module.exports = __webpack_public_path__ + "img/2024-09-19d_1.845facae.jpg";